/**
 * STAY DANGEROUS - Urban Streetwear Theme
 * Main JavaScript File
 */

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  initHeader();
  initMobileMenu();
  initCartDrawer();
  initProductGallery();
  initSizeSelector();
  initQuantitySelector();
  initAddToCart();
  initNewsletterForm();
  initAnimations();
  initMarquee();
});

/**
 * Header scroll effect
 */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    lastScroll = currentScroll;
  });
}

/**
 * Mobile menu toggle
 */
function initMobileMenu() {
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuLinks = document.querySelectorAll('.mobile-menu__link');

  if (!menuBtn || !mobileMenu) return;

  menuBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('open');
    menuBtn.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });

  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}

/**
 * Cart drawer functionality
 */
function initCartDrawer() {
  const cartBtn = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartClose = document.querySelector('.cart-drawer__close');

  if (!cartBtn || !cartDrawer) return;

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtn.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
      closeCart();
    }
  });
}

/**
 * Product gallery with thumbnail selection
 */
function initProductGallery() {
  const mainImage = document.querySelector('.product-page__main-image img');
  const thumbnails = document.querySelectorAll('.product-page__thumbnail');

  if (!mainImage || thumbnails.length === 0) return;

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
      const newSrc = thumbnail.querySelector('img').src;
      mainImage.src = newSrc;
      
      thumbnails.forEach(t => t.classList.remove('active'));
      thumbnail.classList.add('active');
    });
  });
}

/**
 * Size selector
 */
function initSizeSelector() {
  const sizeButtons = document.querySelectorAll('.size-selector__btn');
  const variantInput = document.querySelector('[name="id"]');

  if (sizeButtons.length === 0) return;

  sizeButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // Update variant ID if available
      const variantId = btn.dataset.variantId;
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
    });
  });
}

/**
 * Quantity selector
 */
function initQuantitySelector() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');

  quantitySelectors.forEach(selector => {
    const decreaseBtn = selector.querySelector('[data-quantity-decrease]');
    const increaseBtn = selector.querySelector('[data-quantity-increase]');
    const valueDisplay = selector.querySelector('.quantity-selector__value');
    const input = selector.querySelector('input[name="quantity"]');

    if (!decreaseBtn || !increaseBtn || !valueDisplay) return;

    let quantity = parseInt(input?.value || valueDisplay.textContent) || 1;

    function updateQuantity(newQuantity) {
      quantity = Math.max(1, newQuantity);
      valueDisplay.textContent = quantity;
      if (input) input.value = quantity;
    }

    decreaseBtn.addEventListener('click', () => updateQuantity(quantity - 1));
    increaseBtn.addEventListener('click', () => updateQuantity(quantity + 1));
  });
}

/**
 * Add to cart functionality
 */
function initAddToCart() {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn?.textContent;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          updateCartCount();
          openCartDrawer();
          
          if (submitBtn) {
            submitBtn.textContent = 'Added!';
            setTimeout(() => {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 2000);
          }
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        if (submitBtn) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }
      }
    });
  });
}

/**
 * Update cart count in header
 */
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const countElements = document.querySelectorAll('.header__cart-count');
    
    countElements.forEach(el => {
      el.textContent = cart.item_count;
    });
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

/**
 * Open cart drawer
 */
function openCartDrawer() {
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  
  if (cartDrawer) {
    cartDrawer.classList.add('open');
    cartOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    
    // Refresh cart contents
    refreshCartDrawer();
  }
}

/**
 * Refresh cart drawer contents
 */
async function refreshCartDrawer() {
  const cartContent = document.querySelector('.cart-drawer__content');
  const cartFooter = document.querySelector('.cart-drawer__footer');
  
  if (!cartContent) return;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    if (cart.item_count === 0) {
      cartContent.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty</p>
        </div>
      `;
      if (cartFooter) cartFooter.style.display = 'none';
    } else {
      let itemsHTML = '';
      cart.items.forEach(item => {
        itemsHTML += `
          <div class="cart-item">
            <img src="${item.image}" alt="${item.title}" class="cart-item__image">
            <div class="cart-item__info">
              <h4 class="cart-item__title">${item.product_title}</h4>
              <p class="cart-item__variant">${item.variant_title || ''}</p>
              <p class="cart-item__price">$${(item.price / 100).toFixed(2)}</p>
              <div class="cart-item__quantity">
                <button class="cart-item__qty-btn" data-line="${item.key}" data-action="decrease">−</button>
                <span class="cart-item__qty-value">${item.quantity}</span>
                <button class="cart-item__qty-btn" data-line="${item.key}" data-action="increase">+</button>
              </div>
              <button class="cart-item__remove" data-line="${item.key}" data-action="remove">Remove</button>
            </div>
          </div>
        `;
      });
      
      cartContent.innerHTML = itemsHTML;
      
      const subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
      if (subtotalEl) {
        subtotalEl.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
      }
      
      if (cartFooter) cartFooter.style.display = 'block';
      
      // Add event listeners for quantity buttons
      initCartItemButtons();
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

/**
 * Initialize cart item buttons
 */
function initCartItemButtons() {
  const qtyBtns = document.querySelectorAll('.cart-item__qty-btn, .cart-item__remove');
  
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = btn.dataset.line;
      const action = btn.dataset.action;
      const qtyValue = btn.parentElement?.querySelector('.cart-item__qty-value');
      let quantity = qtyValue ? parseInt(qtyValue.textContent) : 1;

      if (action === 'decrease') quantity = Math.max(0, quantity - 1);
      else if (action === 'increase') quantity += 1;
      else if (action === 'remove') quantity = 0;

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line, quantity })
        });
        
        updateCartCount();
        refreshCartDrawer();
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    });
  });
}

/**
 * Newsletter form
 */
function initNewsletterForm() {
  const forms = document.querySelectorAll('.footer__newsletter-form');

  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const emailInput = form.querySelector('input[type="email"]');
      const submitBtn = form.querySelector('button[type="submit"]');
      
      if (!emailInput?.value) return;

      const originalContent = submitBtn?.innerHTML;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = '...';
      }

      // Shopify customer API for newsletter
      try {
        const response = await fetch('/contact#contact_form', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: `form_type=customer&email=${encodeURIComponent(emailInput.value)}&contact[tags]=newsletter`
        });

        if (submitBtn) {
          submitBtn.innerHTML = '✓';
          setTimeout(() => {
            submitBtn.innerHTML = originalContent;
            submitBtn.disabled = false;
          }, 2000);
        }
        
        emailInput.value = '';
      } catch (error) {
        console.error('Newsletter signup error:', error);
        if (submitBtn) {
          submitBtn.innerHTML = originalContent;
          submitBtn.disabled = false;
        }
      }
    });
  });
}

/**
 * Scroll-based animations
 */
function initAnimations() {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
}

/**
 * Marquee animation
 */
function initMarquee() {
  const marquee = document.querySelector('.marquee__track');
  if (!marquee) return;

  // Clone content for seamless loop
  const content = marquee.innerHTML;
  marquee.innerHTML = content + content;
}

/**
 * Smooth scroll for anchor links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const targetId = this.getAttribute('href');
    if (targetId === '#') return;
    
    const target = document.querySelector(targetId);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});
